'use strict';

module.exports = function calcChildPosition(parent, child, tolerance) {
	const childMid = child.top + child.height * 0.5;
	if (childMid < parent.top - tolerance) {
		return 'above';
	}
	if (childMid > parent.top + parent.height + tolerance) {
		return 'below';
	}
	return 'horizontal';
};
